import React from 'react';
import { getFeatureFlagByNameSelector } from 'store/selectors';
import { setSelectedCategory } from 'store/slices/progressiveHeader';
import { useAppDispatch, useAppSelector } from 'store/store';
import { NikeConnected, PrimaryCategoryData } from 'types';
import { TopNavEventForProgressiveTaxo } from 'utility/analytics-events';
import { dataEmPrepText } from 'utility/common-utils';

interface ConsolidatedNavL0LinksProps {
  navBarData: PrimaryCategoryData[] | undefined;
  setShowDrawer: () => void;
  nikeConnected: NikeConnected;
}

const ConsolidatedNavL0Links: React.FC<ConsolidatedNavL0LinksProps> = ({
  navBarData,
  setShowDrawer,
  nikeConnected,
}) => {
  const dispatch = useAppDispatch();
  const redirectConsolidatedNavLinkToClp = useAppSelector(
    getFeatureFlagByNameSelector('consolidatedNavL0LinkToClp'),
  );

  const handleCategoryClick = (
    event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>,
    category: PrimaryCategoryData,
  ) => {
    if (!redirectConsolidatedNavLinkToClp) {
      event.preventDefault();
      TopNavEventForProgressiveTaxo(category.title, nikeConnected.value);
      dispatch(setSelectedCategory(category.title));
      setShowDrawer();
    }
  };

  return (
    <>
      {navBarData?.slice(0, 4).map((category, index) => (
        <div
          key={`consolidated-${category.title}`}
          className={`hmf-px-xxs hmf-mx-xxxs hmf-display-flex hmf-align-items-center ${
            index === navBarData.length - 1 ? 'hmf-pr-l' : ''
          }`}>
          {redirectConsolidatedNavLinkToClp ? (
            <a
              href={category.link}
              className="consolidated-header-link-title hmf-display-flex hmf-align-items-center hmf-header-xs hmf-mr-xxs"
              onClick={(event) => handleCategoryClick(event, category)}
              data-em={`Header_FeaturedNav_SubCategory_${dataEmPrepText(category.title)}`}>
              {category.title}
            </a>
          ) : (
            <button
              className="consolidated-header-button-title hmf-display-flex hmf-align-items-center hmf-header-xs hmf-p-0 hmf-m-0 hmf-mr-xxs"
              onClick={(event) => handleCategoryClick(event, category)}
              type="button"
              aria-label={`Open ${category.link}`}>
              {category.title}
            </button>
          )}
        </div>
      ))}
    </>
  );
};

export default ConsolidatedNavL0Links;
